import React, { useCallback, useRef, useState } from "react";
import { connect } from "react-redux";
import { FooterIconButton } from "../../base/buttons";
import { translate } from "../../base/i18n";
import { MEDIA_TYPE } from "../../base/media";
import { isLocalTrackMuted } from "../../base/tracks";


function AudioMutedButton({ t, audioMuted, loadMain }) {
    const element = useRef();
    const [isMuted, setIsMuted ] = useState(audioMuted);

    const setAudioMuted = useCallback(() => {     
        APP.UI.toggleAudio(!isMuted);
        setIsMuted(audioMuted);
        if (!loadMain) element.current.checked = !audioMuted;
    }, [audioMuted, isMuted]);

    return (
        <>
            { !loadMain ? 
                <>
                    <input ref={element} type="checkbox" onClick={setAudioMuted} id="audioMuteBtn" />
                    <label htmlFor="audioMuteBtn">
                        <span>{ t("device.hideAudio") }</span>
                    </label>
                </>
                : <FooterIconButton mode="mike" name={ t("device.audio") } checked={!audioMuted} onClick={setAudioMuted} />
            }
        </>
    )
}

function _mapStateToProps(state) {
    const tracks = state['features/base/tracks'];

    return {
        audioMuted: isLocalTrackMuted(tracks, MEDIA_TYPE.AUDIO),
        // audioDisabled: isAudioMuteButtonDisabled(state)
    }
}

export default translate(connect(_mapStateToProps)(AudioMutedButton));